import { render, staticRenderFns } from "./ProviderApprovalHistory.vue?vue&type=template&id=1e06b5dc&scoped=true"
import script from "./ProviderApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ProviderApprovalHistory.vue?vue&type=script&lang=js"
import style0 from "./ProviderApprovalHistory.vue?vue&type=style&index=0&id=1e06b5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06b5dc",
  null
  
)

export default component.exports